'use strict';

module.exports = require('./es6/crc16').default;



//////////////////
// WEBPACK FOOTER
// ./~/crc/lib/crc16.js
// module id = 639
// module chunks = 0